module.exports = __webpack_public_path__ + "44c4002c25f34eaf7db67999dae5576e.png";